export default __webpack_public_path__ + "static/media/logo5.45372ce3.png";